<template lang="pug">
  .estonia
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/estonia-min.png"
      )
      span {{ gettext('Эстония') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Эстония –  член Европейского союза, который по своему территориальному расположению входит в тройку Балтийских стран. Среди них Эстония является наиболее успешной в плане развития экономики. Также Эстония поддерживает теплые отношения со странами бывшего СНГ, в особенности с Россией. Около 20% от всего населения страны (1,3 млн  человек), являются россиянами.') }}
        p {{ gettext('Экономика страны развивается за счет индустриального и аграрного секторов, а именно сферы сельского хозяйства, машиностроения, химической, легкой и пищевой промышленности. Высокого уровня достиг рост в информационной сфере, Эстония тщательно следит за инновационными технологиями в мире и применяет их в ведении бизнеса. Также Эстония известна многим как туристическая страна, с большим количеством прибрежных курортов и гостиничных комплексов.') }}
        p {{ gettext('Хорошая экология, стабильная экономика и сравнительно невысокие цены на проживание среди европейских стран делают Эстонию очень привлекательной точкой назначения для многих иммигрантов.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/visa-rules`")
            span {{ gettext('Visa rules') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/accommodation`")
            span {{ gettext('Accommodation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/healthcare`")
            span {{ gettext('Healthcare') }}

</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/estonia-min.png'})
  },
  name: 'Estonia',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Estonia | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/estonia/index.vue